import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React from 'react';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';

import { getCookies, contactValidation, postDataToWarehouse } from '../../Utils/FormUtils';

import { ContactMethodRadioGroup, EmailField, PhoneField, GenderSelect, PersonSelect, GraduationYearSelect, SubmitButton } from '../Form/Fields';

import useIsTouchDevice from '../../hooks/useIsTouchDevice';

var _ref4 = React.createElement(EmailField, { required: true });

var _ref5 = React.createElement(PhoneField, { required: true });

var _ref6 = React.createElement(GenderSelect, null);

var _ref7 = React.createElement(PersonSelect, null);

var ModalForm = function ModalForm(_ref) {
  var formRef = _ref.formRef,
      successRef = _ref.successRef,
      errorRef = _ref.errorRef,
      handleFormSubmitDiscountCode = _ref.handleFormSubmitDiscountCode,
      setIsSmsSubmission = _ref.setIsSmsSubmission,
      props = _objectWithoutProperties(_ref, ['formRef', 'successRef', 'errorRef', 'handleFormSubmitDiscountCode', 'setIsSmsSubmission']);

  var isTouchDevice = useIsTouchDevice();
  return React.createElement(
    Formik,
    {
      initialValues: Object.assign({
        contactMethod: isTouchDevice ? 'sms' : 'email',
        email: '',
        phone: '',
        gender: '',
        person: '',
        graduationYear: ''
      }, getCookies()),
      validate: function validate(values) {
        return (
          // window.dyAllFieldsRequiredFlag set by DY for A/B testing
          contactValidation(values, window.dyAllFieldsRequiredFlag || false)
        );
      },
      onSubmit: function onSubmit(values, _ref2) {
        var setSubmitting = _ref2.setSubmitting;

        postDataToWarehouse({
          data: values,
          setSubmitting: setSubmitting,
          errorRef: errorRef.current,
          formRef: formRef.current,
          successRef: successRef.current,
          handleFormSubmitDiscountCode: handleFormSubmitDiscountCode,
          setIsSmsSubmission: setIsSmsSubmission,
          redirectLocation: props.redirectLocation,
          isModal: props.isModal
        });
      }
    },
    function (_ref3) {
      var isSubmitting = _ref3.isSubmitting,
          isValid = _ref3.isValid,
          values = _ref3.values,
          setFieldValue = _ref3.setFieldValue;

      return React.createElement(
        Form,
        null,
        React.createElement(ContactMethodRadioGroup, {
          hideLabel: true,
          align: 'center',
          setFieldValue: setFieldValue,
          isTouchDevice: isTouchDevice
        }),
        values.contactMethod === 'email' ? _ref4 : _ref5,
        _ref6,
        _ref7,
        React.createElement(GraduationYearSelect, { formValues: values }),
        React.createElement(SubmitButton, { isValid: isValid, isSubmitting: isSubmitting })
      );
    }
  );
};

ModalForm.propTypes = {
  formRef: PropTypes.object.isRequired,
  successRef: PropTypes.object.isRequired,
  errorRef: PropTypes.object.isRequired,
  handleFormSubmitDiscountCode: PropTypes.func.isRequired,
  setIsSmsSubmission: PropTypes.func,
  redirectLocation: PropTypes.string,
  isModal: PropTypes.bool
};

export default ModalForm;